module.exports = __webpack_public_path__ + "static/media/Delete.ed654f7b.svg";